import { render, staticRenderFns } from "./bank-list.vue?vue&type=template&id=5013b1b8&scoped=true"
import script from "./bank-list.vue?vue&type=script&lang=ts"
export * from "./bank-list.vue?vue&type=script&lang=ts"
import style0 from "./bank-list.vue?vue&type=style&index=0&id=5013b1b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013b1b8",
  null
  
)

export default component.exports